import CityPageTemplate from "../city-template/CityPageTemplate";
import { mountWashingtonConfig } from "./data";

export default function MountWashingtonPage() {
  return <CityPageTemplate config={mountWashingtonConfig} />;
}